export default "__VITE_ASSET__aoHH6SfW__"